module.exports = __webpack_public_path__ + "static/media/sf-test-7.5b4e3682.mp3";